// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import infiniteScroll from 'vue-infinite-scroll'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(infiniteScroll);
Vue.use(ElementUI);

router.beforeEach((to, from, next) => {
  next()
  // let accessToken = Util.localStorageUtil.get('access_token');
//if(accessToken) {
//  next()
//} else {
//  Service.user().getToken({}).then(
//    response => {
//      if(response) {
//        Util.localStorageUtil.set("access_token", response.data);
//      }
//      console.log(Util.localStorageUtil.get('access_token'))
//      next()
//    },
//    err => {
//      next()
//    }
//  );
//}
});
new Vue({
  el: '#app',
  router,
  components: {
    App
  },
  template: '<App/>',
  mounted() {
    document.dispatchEvent(new Event('render-event'))
  }
})


// WEBPACK FOOTER //
// ./src/main.js